import React, { useState } from "react";
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import Items from './items';

function AllItems({ list = [], itemsPerPage }) {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(list.length / itemsPerPage || 1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = list.slice(startIndex, endIndex);

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };



  return (
    <div className="relative w-full text-black my-10 flex flex-col justify-center items-center">
      {list.length > 0 ? (
        <>
          <Items currentItems={currentItems} />

          <div className="flex items-center gap-4 mt-6">
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1}
              className="p-2 bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
              <FaAngleDoubleLeft />
            </button>

            <span className="font-medium">
              Page {currentPage} of {totalPages}
            </span>

            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className="p-2 bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
              <FaAngleDoubleRight />
            </button>
          </div>
        </>
      ) : (
        <p>No items to display.</p>
      )}
    </div>
  );
}

export default AllItems;
